import { BASE_URL } from '../config/config'
import { builder } from '../utils/queryBuilder'
import Fetch from './Fetch'

//upload
// export const uploadFile = async (body) =>
//   await Fetch.post(`${BASE_URL}storage/upload`, body);

export const uploadFile = async body => {
    return Fetch.post(`${BASE_URL}storage/upload`, body)
}

//download
export const downloadFile = path => {
    return Fetch.get(`${BASE_URL}storage/${path}`)
}
